import React from "react";
import { useGlobalContext } from "../context";
import { Link, useParams, useHistory } from "react-router-dom";
import { useTimer } from "react-timer-hook";
import QuestionsList from "./QuestionsList";
import Question from "./Question";
import Loading from "./Loading";

const ExamPage = () => {
  const { apiClient, me } = useGlobalContext();
  const [loading, setLoading] = React.useState(true);
  const [exam, setExam] = React.useState(null);
  const [current, setCurrent] = React.useState(0);
  const [answers, setAnswers] = React.useState({});
  const [autoNext, setAutoNext] = React.useState(false);
  const history = useHistory();
  const { id } = useParams();
  const { seconds, minutes, hours, restart } = useTimer({
    autoStart: false,
    onExpire: async () => {
      await submitExam();
      history.push("/");
    },
  });
  function timeLeft() {
    return parseInt((hours * 60 * 60 + minutes * 60 + seconds) / 90);
  }

  function padInt(num) {
    return num > 9 ? num : `0${num}`;
  }
  function nextQues() {
    if (current < exam.questions.length - 1) {
      setCurrent(current + 1);
    }
  }
  function prevQues() {
    if (current > 0) {
      setCurrent(current - 1);
    }
  }
  function selectAnswer(questionId, option) {
    setAnswers({ ...answers, [questionId]: option });
    if (autoNext) {
      nextQues();
    }
  }

  async function getExam() {
    try {
      const res = await apiClient.get(`/exams/${id}`);
      if (res.status >= 200 && res.status < 300) {
        setExam(res.data.exam);
        restart(new Date(res.data.endDate));
      }
    } catch (error) {
      alert(error);
      console.error(error.response.data);
    } finally {
      setLoading(false);
    }
  }
  React.useEffect(() => getExam(), [id]);

  async function handleSubmit() {
    const sure = window.confirm("Are you sure to submit and finish this exam?");
    if (!sure) return;
    submitExam();
  }

  async function submitExam() {
    setLoading(true);
    try {
      const ans = [];
      for (const key in answers) {
        ans.push({ question: key, answer: answers[key] });
      }
      const res = await apiClient.post(`/exams/${id}/submit`, ans);
      if (res.status >= 200 && res.status < 300) {
        if (res.data.passed) {
          alert(`Congratulations! you passed.`);
        } else {
          alert(
            "FAILED first attempt, To obtain new login info to re-take final, call 800-877-7008 during business hours or text to 626-226-9686 after hours. Second failure requires re-enrollment"
          );
        }
        await me();
        history.push("/");
      }
    } catch (error) {
      alert(error);
      console.error(error.response.data);
    } finally {
      setLoading(false);
    }
  }

  if (loading) {
    return <Loading />;
  }
  if (!exam) {
    return (
      <div className="text-center">
        <h5 className="text-muted display-6">Not Found</h5>
        <Link className="btn btn-outline-secondary px-5" to="/">
          Go Back
        </Link>
      </div>
    );
  }

  return (
    <div className="row">
      <div className="col-12 col-lg-5 col-xl-4">
        <QuestionsList
          answers={answers}
          questions={exam.questions}
          current={current}
          setCurrent={setCurrent}
        />
      </div>
      <div className="col-12 col-lg-7 col-xl-8">
        <div className="d-flex align-items-center justify-content-between mb-3">
          <div>
            <h4 className="mb-0">
              Question {current + 1} of {exam.questions.length}
            </h4>
            <div className="form-check form-switch mt-1">
              <input
                type="checkbox"
                className="form-check-input"
                id="auto-check-input"
                onClick={(e) => setAutoNext(e.target.checked)}
              />
              <label className="form-check-label" htmlFor="auto-check-input">
                Auto Next
              </label>
            </div>
          </div>
          <button
            className={`btn shadow-sm position-relative  ${
              timeLeft() < 10
                ? "btn-outline-danger"
                : timeLeft() < 20
                ? "btn-outline-warning"
                : "btn-outline-success"
            }`}
            onClick={handleSubmit}
          >
            Submit
            <span className="fw-bold">
              {" "}
              {padInt(hours)}:{padInt(minutes)}:{padInt(seconds)}
            </span>
            <div
              className={`position-absolute end-0 bottom-0 ${
                timeLeft() < 10
                  ? "bg-danger"
                  : timeLeft() < 20
                  ? "bg-warning"
                  : "bg-success"
              }`}
              style={{
                zIndex: -1,
                height: "0.375rem",
                width: `${timeLeft()}%`,
              }}
            ></div>
          </button>
        </div>
        <Question
          question={exam.questions[current]}
          answers={answers}
          selectAnswer={selectAnswer}
        />
        <div className="d-flex mt-3">
          <button
            className="btn btn-secondary shadow-sm w-50 me-3"
            onClick={prevQues}
            disabled={current === 0}
          >
            Previous
          </button>
          <button
            className="btn btn-secondary shadow-sm w-50"
            onClick={nextQues}
            disabled={current === exam.questions.length - 1}
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default ExamPage;
